<span
  class="multiDay-jobType"
  [attr.data-cy]="'multi-day-job-type-' + jobType"
  *ngIf="jobType">
  {{ ("jobTypeEnum." + jobType | i18n) || jobType }}
</span>
<div class="multiDay-shifts-list">
  <div
    *ngFor="let shift of shifts"
    class="d-flex">
    <div
      class="job-shift-tag"
      [attr.data-cy]="'job-shift-tag-' + shift.id">
      {{
        shift.label ? shift.label : ("shifts." + shift.shift | i18n | titlecase)
      }}
    </div>
    ( {{ shift.from | time }} - {{ shift.to | time }} )
  </div>
</div>
<mat-icon
  *ngIf="!isDisabled"
  (click)="$event.stopPropagation(); openEditDialog()"
  svgIcon="pencil-outline"
  matListIcon
  [matTooltip]="('editShifts' | i18n) || 'Schichten bearbeiten'"
  class="edit-shift-icon text-primary"
  data-cy="edit-multiday-shift-button"></mat-icon>
